import apiHandler from '../apiHandler';
import { METHOD } from '../constants';
import { PATHS } from '../utils';

const submitOrderToDTNA = async (
  authorization: string,
  requestPayload: any
): Promise<unknown> => {
  const response = await apiHandler({
    url: PATHS.SUBMIT_ORDERS,
    method: METHOD.POST,
    headers: { authorization },
    reqObj: requestPayload
  });
  if (!response.ok) throw new Error(response.statusText);

  return (await response.json()) as Promise<unknown>;
};

export default submitOrderToDTNA;